var _rect, _text, _g, _g2, _g3, _g4, _g5, _line, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMcpExample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fbbf24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f59e0b"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 250,
    fill: "#0f172a",
    rx: 12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 35,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "MCP in Action: Real-time Gold Price")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 130)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 45,
    fill: "url(#blueGrad)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "45;48;45",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -8,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 14
  }, "AI"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 10,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Agent"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "MCP Client"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(170, 105)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 0,
    stroke: "#22c55e",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,100;100,100",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "105,0 95,-6 95,6",
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: -12,
    textAnchor: "middle",
    fill: "#22c55e",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "getGoldPrice()"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(170, 155)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 0,
    y2: 0,
    stroke: "#fbbf24",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,100;100,100",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.8s"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "-5,0 5,-6 5,6",
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 18,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "$2,045.30"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -45,
    width: 90,
    height: 90,
    rx: 12,
    fill: "#1e293b",
    stroke: "#f59e0b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -8,
    r: 18,
    fill: "url(#goldGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -3,
    textAnchor: "middle",
    fill: "#78350f",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 14
  }, "$"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 30,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Gold API"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "MCP Server"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(480, 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -40,
    width: 100,
    height: 80,
    rx: 10,
    fill: "#1e293b",
    stroke: "#22c55e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -15,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "Result"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 10,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 16
  }, "$2,045"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 28,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "per ounce"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 375,
    y1: 130,
    x2: 420,
    y2: 130,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 230,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Agent calls tool, gets data, done. Simple one-way flow.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcpExample);
export default __webpack_public_path__ + "static/media/mcp-example.b1f36bdfb78f1a0a960aba1bee1372a6.svg";
export { ForwardRef as ReactComponent };